import React, { useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import "./Sidenav.scss";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { config } from "../../config/config";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import { updateAlert, updateSourceInputs } from "../../redux/actions";
import sidenavData from "../../../assets/data/sidenavData.json";

const useStyles = makeStyles(() => ({
  list: {
    width: 500,
  },
  typographyStyle: {
    fontFamily: "Hind Siliguri",
    fontSize: 14,
    color: "#46596a",
    minWidth: 400,
    maxWidth: 600,
  },
  contained: {
    color: "white",
    backgroundColor: "#46596a",
    marginRight: 4,
    fontSize: 11,
    padding: 10,
    height: 23,
    minWidth: 15,
    textTransform: "capitalize",
    fontFamily: "Hind Siliguri",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#46596a",
      boxShadow: "none",
    },
  },
  outlined: {
    borderColor: "#46596a",
    backgroundColor: "transparent",
    color: "#46596a",
    marginRight: 4,
    fontSize: 11,
    padding: 10,
    height: 23,
    minWidth: 15,
    textTransform: "capitalize",
    fontFamily: "Hind Siliguri",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
}));

const alertTheme = createTheme({
  palette: {
    success: {
      main: "#f0f2f4",
      contrastText: "#46596a",
    },
    info: {
      main: "#f0f2f4",
      contrastText: "#46596a",
    },
    error: {
      main: "#f0f2f4",
      contrastText: "#46596a",
    },
  },
  "& .MuiAlert-filledSuccess": {
    color: "#46596a",
    //font-weight: 1000,
    backgroundColor: "#f0f2f4",
    width: "800px",
  },
});

function Alert(props) {
  const classes = useStyles();
  return (
    <ThemeProvider theme={alertTheme}>
      <MuiAlert
        className={classes.typographyStyle}
        elevation={6}
        variant="filled"
        {...props}
      />
    </ThemeProvider>
  );
}

function SideNavNew(props) {
  const { user, user_detail, updateAlert, updateSourceInputs } = props;

  const location = useLocation();
  const [user_restriction, setuser_restriction] = useState([]);
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Current_Usecase = URL.split("/").pop();
  let api = config.api.api_url;

  //Close alert snackbar
  const handleClose = () => {
    updateAlert({ ...user.alertInfo, open: false, closeFlag: true });
  };

  const clearReduxState = () => {
    updateSourceInputs("current_iqvia_source_file_id", []);
    updateSourceInputs("current_nielsen_source_file_id_list", []);
    updateSourceInputs("current_iqvia_source_file_id", "");
    updateSourceInputs("current_nielsen_source_file_id", "");
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const getUserRestriction = () => {
    if (
      user_detail &&
      user_detail.user_info &&
      Array.isArray(user_detail.user_info.allowed_sidenav) &&
      user_detail.user_info.allowed_sidenav.length > 0
    ) {
      const Main_Routes = user_detail.user_info.allowed_sidenav;
      const Side_Nav_Routes = Main_Routes?.find((item) => item.is_sidenav);

      const Side_Nav_Category =
        Side_Nav_Routes?.sidenav_details?.sidebar_details || [];
      const Usecases = Side_Nav_Routes?.sidenav_details?.usecases || [];

      let AllRoutes = [];
      Side_Nav_Category?.forEach((mainItem) => {
        AllRoutes = [...AllRoutes, ...(Usecases?.[mainItem.value] || [])];
      });

      const FinalSideNavRoutes = AllRoutes?.map((sideNavItem) => {
        return {
          id: `harbor/local_reporting/${sideNavItem.value}`,
          name: sideNavItem.label,
          materialUiIconName: sideNavItem.materialUiIconName,
          materialUiClassName: "material-icons-outlined",
          specialStyling: false,
          component: sideNavItem.component,
          app_name: "Harbor",
          is_sidenav: false,
          sidenav_details: {},
        };
      });
      setuser_restriction(FinalSideNavRoutes);
    } else {
      const Main_Routes = sidenavData;
      const Side_Nav_Routes = sidenavData?.find((item) => item.is_sidenav);

      const Side_Nav_Category =
        Side_Nav_Routes?.sidenav_details?.sidebar_details || [];
      const Usecases = Side_Nav_Routes?.sidenav_details?.usecases || [];

      let AllRoutes = [];
      Side_Nav_Category?.forEach((mainItem) => {
        AllRoutes = [...AllRoutes, ...(Usecases?.[mainItem.value] || [])];
      });

      const FinalSideNavRoutes = AllRoutes?.map((sideNavItem) => {
        return {
          id: `harbor/local_reporting/${sideNavItem.value}`,
          name: sideNavItem.label,
          materialUiIconName: sideNavItem.materialUiIconName,
          materialUiClassName: "material-icons-outlined",
          specialStyling: false,
          component: sideNavItem.component,
          app_name: "Harbor",
          is_sidenav: false,
          sidenav_details: {},
        };
      });

      setuser_restriction(FinalSideNavRoutes);
      // setuser_restriction([]);
    }
  };

  const handleNavClick = (e, path) => {
    const Target_URL = path.split("/").pop();
    e.preventDefault(); // ⛔ stop default <NavLink> navigation
    if (Current_Usecase === Target_URL) return;

    // ✅ Clear Redux state
    clearReduxState();

    // ✅ Navigate manually
    history.push(`/${path}`);
  };

  useEffect(() => {
    getUserRestriction();
  }, []);

  return (
    <>
      <aside
        className={`${user.theme} ${
          user.screen.isSidenavBarExpanded
            ? "sidenav-expanded"
            : "sidenav-collapsed"
        }`}
      >
        <nav>
          <div>
            {
              <div>
                <br></br>
                {user_restriction &&
                  user_restriction.length > 0 &&
                  user_restriction.map((obj) => (
                    <NavLink
                      to={`/${obj.id}`}
                      className={`${
                        location.pathname === `/${obj.id}`
                          ? "nav-menu-container-active"
                          : "nav-menu-container"
                      }`}
                      key={obj.id}
                      onClick={(e) => handleNavClick(e, obj.id)}
                    >
                      <div className={"nav-item disabled-style active"}>
                        <i className={`material-icons-outlined nav-icon`}>
                          <span class="material-symbols-outlined">
                            {obj.materialUiIconName}
                          </span>
                        </i>
                      </div>
                      <p
                        style={{
                          fontWeight: `${
                            location.pathname === obj.id ? "900" : "500"
                          }`,
                        }}
                        className="icon-title"
                      >
                        {obj.name}
                      </p>
                    </NavLink>
                  ))}
              </div>
            }
          </div>
        </nav>
      </aside>
      <ThemeProvider theme={alertTheme}>
        <Snackbar
          open={user.alertInfo.open}
          autoHideDuration={config.messages.timeout}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} icon={false} severity="success">
            {user.alertInfo.message.split("\n").map((i, key) => {
              return <div key={key}>{i}</div>;
            })}
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  user_detail: state.user_detail,
  user_detail: state.user_detail,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(SideNavNew);
